import React from 'react';
import {Handle, NodeProps, Position} from 'reactflow';
import {SlideNodeData} from '../nodes.types';

function SlideNode({data}: NodeProps<SlideNodeData>): JSX.Element {
    const {slide, preview} = data;

    return (
        <div className="rf-slide-node">
            <div className="rf-slide-node__preview">
                {preview?.imgSrc ? (
                    <img src={preview.imgSrc} alt={slide.name} />
                ) : (
                    <div className="rf-slide-node__preview-empty">
                        <span>{slide.name[0]?.toUpperCase()}</span>
                    </div>
                )}
            </div>

            <div className="rf-slide-node__footer">
                <span className="rf-slide-node__name" title={slide.name}>
                    {slide.name}
                </span>
            </div>

            <Handle type="target" isConnectable={false} position={Position.Left} id="prev-slide" className="rf-slide-node__handle-seq" />
            <Handle type="source" isConnectable={false} position={Position.Right} id="next-slide" className="rf-slide-node__handle-seq" />

            <Handle
                type="source"
                isConnectable={false}
                position={Position.Bottom}
                id="to-questions"
                style={{left: '10%'}}
                className="rf-slide-node__handle-questions"
            />
            <Handle
                type="target"
                position={Position.Bottom}
                id="incoming"
                style={{left: '50%'}}
                className="rf-slide-node__handle-incoming"
            />
        </div>
    );
}

export default SlideNode;
